import FileUploadService from '../services/file-upload/file-upload.service'

/**
 * Opens a bill's source document in a new browser tab, so it can sit beside the row being checked or
 * corrected. The tab is opened synchronously inside the click, and pointed at the short-lived signed
 * URL once that arrives: opening it only after the request would be blocked as a pop-up.
 * Resolves false when the URL could not be fetched (the blank tab is closed again).
 */
export const openBillDocument = async (billDocumentId: string): Promise<boolean> => {
  const tab = window.open('', '_blank')
  try {
    const url = await new FileUploadService().getBillDocumentPreviewUrl(billDocumentId)
    if (tab) {
      tab.opener = null
      tab.location.href = url
    } else {
      window.open(url, '_blank', 'noopener')
    }
    return true
  } catch (error) {
    console.log(error)
    tab?.close()
    return false
  }
}
